<div
  class="expandable-copy-wrapper"
  #copyWrapper
  [class.show-less]="!showAll"
  [class.show-all]="showAll || !isExpandable"
  [innerHTML]="text"
></div>
<div *ngIf="isExpandable" class="expandable-copy-btn-wrapper">
  <div class="btn btn-secondary" (click)="showAll = !showAll">
    <span *ngIf="showAll">{{ 'LESS' | translate }}</span>
    <span *ngIf="!showAll">{{ 'MORE' | translate }}</span>
  </div>
</div>
